export enum detailsMetadata {
  experimentType = 'experimentType',
  experimentTestPeriod = 'experimentTestPeriod',
  experimentStart = 'experimentStart',
  experimentID = 'experimentID',
  projectedExperimentEnd = 'projectedExperimentEnd',
  createdBy = 'createdBy',
  experimentState = 'experimentState',
  winningCriteria = 'winningCriteria',
  experimentEnd = 'experimentEnd',
  locales = 'locales',
  holdout = 'holdout',
  randomlySplitVariants = 'randomlySplitVariants',
  autoSelectWinner = 'autoSelectWinner',
  initialSendSize = 'initialSendSize',
  holdoutGroupAttribution = 'holdoutGroupAttribution',
}

export const BASE_EXPERIMENT_DETAILS_LIST = [
  detailsMetadata.experimentType,
  detailsMetadata.winningCriteria,
  detailsMetadata.experimentState,
  detailsMetadata.experimentID,
  detailsMetadata.experimentStart,
  detailsMetadata.experimentEnd,
  detailsMetadata.createdBy,
  detailsMetadata.randomlySplitVariants,
];

export const BASE_EXPERIMENT_DETAILS_LIST_WITH_PROJECTED_END_TIME = [
  detailsMetadata.experimentType,
  detailsMetadata.winningCriteria,
  detailsMetadata.experimentState,
  detailsMetadata.experimentID,
  detailsMetadata.experimentStart,
  detailsMetadata.projectedExperimentEnd,
  detailsMetadata.createdBy,
  detailsMetadata.randomlySplitVariants,
];

export const RANDOMLY_SPLIT_VARIANTS_OFF_BLAST = [
  detailsMetadata.initialSendSize,
  detailsMetadata.autoSelectWinner,
  detailsMetadata.experimentTestPeriod,
];

export const RANDOMLY_SPLIT_VARIANTS_OFF_TRIGGER = [
  detailsMetadata.autoSelectWinner,
  detailsMetadata.experimentTestPeriod,
];

export const HOLDOUT_GROUP_ON_BLAST = [
  detailsMetadata.holdout,
  detailsMetadata.holdoutGroupAttribution,
];

export const HOLDOUT_GROUP_OFF_BLAST = [detailsMetadata.holdout];
